export default __webpack_public_path__ + "static/media/avatar-gray.29b4d10e.svg";